module.exports = __webpack_public_path__ + "static/media/bind_map.46907ec5.jpg";